import { httpClient } from "@/services";

export default {
	state: {
		settingsSchedule: [],
		scheduleSchedule: [],
		filtersSchedule: {},
		editSchedule: {},
		calendarMonthData2: [],
	},
	mutations: {

		updateSchedule(state, { settings, schedules, filters }) {
			const mock = [
				{
					"date": "2025-09-28",
					"isDisabled": true
				},
				{
					"date": "2025-09-29",
					"isDisabled": true
				},
				{
					"date": "2025-09-30",
					"isDisabled": true
				},
				{
					"date": "2025-10-01",
					"total_time": "08:52:00",
					"name": "Wednesday",
					"check_in": "09:21:47",
					"check_out": "18:14:30",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-02",
					"total_time": "10:10:00",
					"name": "Thursday",
					"check_in": "08:20:17",
					"check_out": "18:30:38",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-03",
					"total_time": "08:47:00",
					"name": "Friday",
					"check_in": "09:12:21",
					"check_out": "17:59:37",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-04",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-05",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-06",
					"total_time": "08:49:00",
					"name": "Monday",
					"check_in": "09:16:06",
					"check_out": "18:05:31",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-07",
					"total_time": "09:45:00",
					"name": "Tuesday",
					"check_in": "08:24:25",
					"check_out": "18:10:13",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-08",
					"total_time": "08:20:00",
					"name": "Wednesday",
					"check_in": "09:50:10",
					"check_out": "18:10:24",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-09",
					"total_time": "09:09:00",
					"name": "Thursday",
					"check_in": "08:53:58",
					"check_out": "18:03:53",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-10",
					"total_time": "09:10:00",
					"name": "Friday",
					"check_in": "08:53:16",
					"check_out": "18:03:35",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-11",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-12",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-13",
					"total_time": "08:34:00",
					"name": "Monday",
					"check_in": "09:28:23",
					"check_out": "18:02:55",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-14",
					"total_time": "09:53:00",
					"name": "Tuesday",
					"check_in": "08:33:10",
					"check_out": "18:26:56",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-15",
					"total_time": "07:10:00",
					"name": "Wednesday",
					"check_in": "11:11:41",
					"check_out": "18:22:19",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-16",
					"total_time": "09:13:00",
					"name": "Thursday",
					"check_in": "08:57:13",
					"check_out": "18:11:11",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-17",
					"total_time": "08:59:00",
					"name": "Friday",
					"check_in": "09:17:21",
					"check_out": "18:16:54",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-18",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-19",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-20",
					"total_time": "09:05:00",
					"name": "Monday",
					"check_in": "09:04:53",
					"check_out": "18:10:47",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-21",
					"total_time": "09:38:00",
					"name": "Tuesday",
					"check_in": "08:21:38",
					"check_out": "18:00:20",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-22",
					"total_time": "09:16:00",
					"name": "Wednesday",
					"check_in": "08:59:17",
					"check_out": "18:15:21",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-23",
					"total_time": "09:25:00",
					"name": "Thursday",
					"check_in": "08:38:49",
					"check_out": "18:04:35",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "Windows",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-24",
					"total_time": "03:20:00",
					"name": "Friday",
					"check_in": "08:20:50",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": 0,
					"duty": false,
					"absent": 0,
					"vacation": 0,
					"holiday_name": "",
					"today": true,
					"user_agent_out": "",
					"user_agent_in": "Windows",
					"isDisabled": false
				},
				{
					"date": "2025-10-25",
					"total_time": "00:00:00",
					"name": "Saturday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-26",
					"total_time": "00:00:00",
					"name": "Sunday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "00:00:00",
					"schedule_out": "00:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-27",
					"total_time": "09:16:04",
					"name": "Monday",
					"check_in": "08:59:17",
					"check_out": "18:15:21",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-28",
					"total_time": "00:00:00",
					"name": "Tuesday",
					"check_in": "09:08:17",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-29",
					"total_time": "00:00:00",
					"name": "Wednesday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-30",
					"total_time": "00:00:00",
					"name": "Thursday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-10-31",
					"total_time": "00:00:00",
					"name": "Friday",
					"check_in": "",
					"check_out": "",
					"schedule_in": "09:00:00",
					"schedule_out": "18:00:00",
					"sick": false,
					"duty": false,
					"absent": false,
					"vacation": false,
					"holiday_name": "",
					"today": false,
					"user_agent_out": "",
					"user_agent_in": "",
					"isDisabled": false
				},
				{
					"date": "2025-11-01",
					"isDisabled": true
				}
			];

			state.calendarMonthData2 = mock;
			
			state.settingsSchedule = settings;
			state.scheduleSchedule = schedules;
			state.filtersSchedule = filters;
		},
		updateEditSchedule(state, { values }) {
			state.editSchedule = values;
		},
	},
	actions: {

		async deleteAccountSchedule({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/schedule/${ id }`);
				if (data && data.status) {
					dispatch('getAccountScheduleList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountScheduleList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/schedule");
				if (data) {
					commit('updateSchedule', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountScheduleEdit({ commit, dispatch }, values ) {
			// dispatch("actionPreloader", true);
			try {
				const { id } = values;
				const { data } = await httpClient.put(`/info/schedule/${ id }`, values);
				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountScheduleSave({ commit, dispatch }, values) {
			// dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/info/schedule", values);
				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountScheduleEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/schedule/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditSchedule', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editSchedulev: s => s.editSchedule,
		settingsSchedule: s => s.settingsSchedule,
		scheduleSchedule: s => s.scheduleSchedule,
		filtersSchedule: s => s.filtersSchedule,
		calendarMonthData2: s => s.calendarMonthData2,

	},
};
